<script lang="ts">
import { defineComponent } from 'vue'
import Toast from 'primevue/toast'
import ConfirmDialog from 'primevue/confirmdialog'
import { useProvideTheme } from './config/theme/useTheme'
import { useProvideLang } from './config/i18n/useLang'
import { useNetwork } from '@vueuse/core'
import { DotNoConnectionOverlay } from '@/common/components'

export default defineComponent({
  components: {
    Toast,
    ConfirmDialog,
    DotNoConnectionOverlay,
  },
  setup() {
    useProvideTheme()
    useProvideLang()

    const { isOnline } = useNetwork()

    return { isOnline }
  },
})
</script>

<template>
  <Toast />
  <ConfirmDialog />
  <DotNoConnectionOverlay v-if="!isOnline" />
  <router-view v-if="isOnline" />
</template>

<style lang="scss">
html {
  @apply box-border w-full;
  @apply antialiased scroll-smooth scrollbar-hide;
  body {
    @apply w-full overflow-x-hidden;
  }
}

label {
  @apply font-semibold text-sm;
}

input {
  @apply w-full;
}

.icon {
  &--sm {
    @apply text-base;
  }
  &--md {
    @apply text-lg;
  }
  &--lg {
    @apply text-xl;
  }
  &--xl {
    @apply text-2xl;
  }
}

.fade-enter-active,
.fade-leave-active {
  @apply transition-all duration-200 ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
  @apply opacity-0;
}
</style>
